import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SetViewedService {
  constructor(private httpClient: HttpClient) { }

  public SetViewed(claimId: number) {
    return this.httpClient.put(`${environment.apiServer}/Adjuster/Claim/SetViewed`, {claimId});
  }
}
